import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'jmkw-slider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderComponent {
  @Input() value? = 50;
  @ViewChild('slider') slider!: ElementRef<any>;
  @Output() sliderChange = new EventEmitter<number>();

  onSliderChange(e: any) {
    this.sliderChange.emit(Number(e.target.value));
  }
}
